<template>
  <div >
    <div v-if="isLoading">Cargando</div>
    <div v-if="!isLoading">
      <h5>{{ so[0].name }}</h5>
      <b-table fluid :items="saleOrderItems" :fields="saleOrderItemsFields">
        <template #cell(x_student_id)="data">
          {{ data.item.x_student_id[1] }}
        </template>
        <template #cell(x_class_id)="data">
          {{ data.item.x_class_id[1] }}
        </template>
        <template #cell(x_enrollment_fee)="data">
          <div v-if="item.x_sale_order_line_id[0] != data.item.id">
            <b-form-input
              @change="recalculate()"
              id="input-enrollment"
              v-model="data.item.x_enrollment_fee"
              placeholder="Inscripcion"
              trim
            ></b-form-input>
          </div>
          <div v-if="item.x_sale_order_line_id[0] == data.item.id">
            ${{ data.item.x_enrollment_fee }}
          </div>
        </template>
        <template #cell(x_march_fee)="data">
          <div v-if="item.x_sale_order_line_id[0] != data.item.id">
            <b-form-input
              @change="recalculate()"
              id="input-enrollment"
              v-model="data.item.x_march_fee"
              placeholder="Inscripcion"
              trim
            ></b-form-input>
          </div>
          <div v-if="item.x_sale_order_line_id[0] == data.item.id">
            ${{ data.item.x_march_fee }}
          </div>
        </template>
        <template #cell(x_monthly_fee)="data">
          <div v-if="item.x_sale_order_line_id[0] != data.item.id">
            <b-form-input
              @change="recalculate()"
              id="input-enrollment"
              v-model="data.item.x_monthly_fee"
              placeholder="Inscripcion"
              trim
            ></b-form-input>
          </div>
          <div v-if="item.x_sale_order_line_id[0] == data.item.id">
            ${{ data.item.x_monthly_fee }}
          </div>
        </template>
        <template #cell(x_december_fee)="data">
          <div v-if="item.x_sale_order_line_id[0] != data.item.id">
            <b-form-input
              @change="recalculate()"
              id="input-enrollment"
              v-model="data.item.x_december_fee"
              placeholder="Inscripcion"
              trim
            ></b-form-input>
          </div>
          <div v-if="item.x_sale_order_line_id[0] == data.item.id">
            ${{ data.item.x_monthly_fee }}
          </div>
        </template>
        <template #cell(actions)="data">
          <div v-if="item.x_sale_order_line_id[0] == data.item.id">Eliminando</div>
        </template>

      </b-table>
      <div v-if="saleOrderItems.length > 1">
        <h5>Proximas Cuotas</h5>
        <b-table :items="cuentaCorriente" :fields="cuentaCorrienteFields">
          <template #cell(price_unit)="data">
          ${{ data.item.price_unit }}
        </template>
        </b-table>
      </div>
      <b-row>
        <b-col>
          <b-button variant="danger" @click="eliminarInscripcion()">Eliminar Iniscripcion</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import invoiceManagement from '../mixins/invoiceManagement'

export default {
  name: 'eliminar-inscripcion',
  mixins: [invoiceManagement],
  props: ['so', 'sol', 'item', 'family'],
  data () {
    return {
      isLoading: true,
      saleItems: {},
      saleOrderItemsFields: [
        { key: 'x_student_id', label: 'Alumno' },
        { key: 'x_class_id', label: 'Clase' },
        { key: 'x_enrollment_fee', label: 'Inscripcion' },
        { key: 'x_march_fee', label: 'Marzo' },
        { key: 'x_monthly_fee', label: 'Cuota' },
        { key: 'x_december_fee', label: 'Diciembre' },
        { key: 'actions', label: 'Acciones' }
      ],
      cuentaCorriente: [],
      cuentaCorrienteFields: [
        { key: 'name', label: 'Descripción' },
        { key: 'price_unit', label: 'Precio' }
      ],
      students: ' '
    }
  },
  computed: {
    saleOrderItems () {
      const ret = []
      this.sol.map(function (item) {
        if (!item.is_downpayment & item.product_uom_qty > 0) {
          ret.push(item)
        }
      })
      return ret
    },
    remainingSaleOrderItems () {
      const ret = []
      this.sol.map(function (v) {
        if (!v.is_downpayment) {
          ret.push(v)
        }
      })
      return ret
    }
  },
  
  async created () {
    this.isLoading = true
    console.log(this.saleOrderItems)
    this.recalculate()
    this.isLoading = false
  },
  methods: {
    
    /* async onDemandCreateDraftInvoices (so) {
      const items = await SaleOrderLinesService.list({ order_id: so.id, is_downpayment: false })
      this.saleOrder = so
      const totals = { enrollment: 0, march: 0, monthly: 0, december: 0 }
      let students = ''

      for (let j = 0; j < items.length; j++) {
        if (items[j].id !== this.item.x_sale_order_line_id[0]) {
          totals.enrollment += items[j].x_enrollment_fee
          totals.march += items[j].x_march_fee
          totals.monthly += items[j].x_monthly_fee
          totals.december += items[j].x_december_fee
        }
        
        if (students.length === 0) {
          students += ' ' + items[j].x_student_id[1] + ' en ' + items[j].product_id[1]
        } else {
          students += ' y ' + items[j].x_student_id[1] + ' en ' + items[j].product_id[1]
        }
      }
      await this.createDraftInvoices(totals, students)
    },
    async createDraftInvoices (totals, students) {
      totals.total = totals.enrollment + totals.march + totals.monthly + totals.december
      
      if (totals.enrollment === 0) { totals.enrollment = 1 }
      if (totals.march === 0) { totals.march = 1 }
      if (totals.monthly === 0) { totals.monthly = 1 }
      if (totals.december === 0) { totals.december = 1 }

      await this.createAdvPayments(totals, students)
      console.log('xxxx')
      let sol = {}
      console.log('xxxx')
      this.saleOrder = await SaleOrdersService.read(this.so[0].id)
      this.saleOrder = this.saleOrder[0]
      console.log('xxxx')
      sol = await SaleOrderLinesService.read(this.saleOrder.order_line, [])
      console.log('SOL', sol)
      console.log('xxxx')
      await this.updateSolNames(sol, students)
      sol = await SaleOrderLinesService.read(this.saleOrder.order_line, [])
      await this.updateInvoiceNames(sol)
      console.log(this.item.id)
    },

    async updateInvoiceNames (sol) {
      for (let i = 0; i < sol.length; i++) {
        if (sol[i].is_downpayment) {
          await AccountMoveLineService.update(sol[i].invoice_lines, { name: sol[i].name })
        }
      }
    },

    async updateSolNames (sol, students) {
      let index = 0
      const names = [
        'Cuota de inscripción de ' + students,
        'Cuota de Marzo de ' + students,
        'Cuota de Abril de ' + students,
        'Cuota de Mayo de ' + students,
        'Cuota de Junio de ' + students,
        'Cuota de Julio de ' + students,
        'Cuota de Agosto de ' + students,
        'Cuota de Septiembre de ' + students,
        'Cuota de Octubre de ' + students,
        'Cuota de Noviembre de ' + students,
        'Cuota de Diciembre de ' + students
      ]
      for (let i = 0; i < sol.length; i++) {
        if (sol[i].is_downpayment) {
          await SaleOrderLinesService.update([sol[i].id], {
            name: names[index]
          })
          index++
        }
      }
    },
    async createAdvPayments (totals, students) {
      const advEnrollment = {
        advance_payment_method: 'fixed',
        fixed_amount: totals.enrollment.toString(),
        amount: '0',
        display_name: 'Inscripción de ' + students
      }

      const advMarch = {
        advance_payment_method: 'fixed',
        fixed_amount: totals.march.toString(),
        amount: '0',
        display_name: 'Cuota de Marzo de ' + students
      }
      
      const advMonthly = {
        advance_payment_method: 'fixed',
        fixed_amount: totals.monthly.toString(),
        amount: '0',
        display_name: 'Cuota Mensual de ' + students
      }

      const advDecember = {
        advance_payment_method: 'fixed',
        fixed_amount: totals.december.toString(),
        amount: '0',
        display_name: 'Cuota de Diciembre de ' + students
      }
      console.log(this.saleOrder)
      await SaleAdvancePaymentService.execute('create_invoices', [
        [await SaleAdvancePaymentService.create(advEnrollment)],
        {
          context: {
            active_id: this.saleOrder.id,
            active_ids: [this.saleOrder.id],
            active_model: 'sales.order'
          }
        }
      ])

      await SaleAdvancePaymentService.execute('create_invoices', [
        [await SaleAdvancePaymentService.create(advMarch)],
        {
          context: {
            active_id: this.saleOrder.id,
            active_ids: [this.saleOrder.id],
            active_model: 'sales.order'
          }
        }
      ])

      const months = ['Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre']
      for (let i = 0; i < months.length; i++) {
        advMonthly.display_name = 'Cuota de ' + months + ' de ' + students
        await SaleAdvancePaymentService.execute('create_invoices', [
          [await SaleAdvancePaymentService.create(advMonthly)],
          {
            context: {
              active_id: this.saleOrder.id,
              active_ids: [this.saleOrder.id],
              active_model: 'sales.order'
            }
          }
        ])
      }

      await SaleAdvancePaymentService.execute('create_invoices', [
        [await SaleAdvancePaymentService.create(advDecember)],
        {
          context: {
            active_id: this.saleOrder.id,
            active_ids: [this.saleOrder.id],
            active_model: 'sales.order'
          }
        }
      ])
    }, */
    recalculate () {
      this.cuentaCorriente = []
      this.students = ''
      this.totals = { x_enrollment_fee: 0, x_march_fee: 0, x_monthly_fee: 0, x_december_fee: 0 }
      for (let i = 0; i < this.saleOrderItems.length; i++) {
        if (this.item.x_sale_order_line_id[0] !== this.saleOrderItems[i].id) {
          if (this.students.length > 0) {
            this.students += ' y '
          }
          this.students += this.saleOrderItems[i].x_student_id[1] + ' en ' + this.saleOrderItems[i].product_id[1]
          this.totals.x_enrollment_fee += parseInt(this.saleOrderItems[i].x_enrollment_fee)
          this.totals.x_march_fee += parseInt(this.saleOrderItems[i].x_march_fee)
          this.totals.x_monthly_fee += parseInt(this.saleOrderItems[i].x_monthly_fee)
          this.totals.x_december_fee += parseInt(this.saleOrderItems[i].x_december_fee)
        }
      }
      for (let i = 0; i < this.sol.length; i++) {
        if (this.sol[i].is_downpayment && (this.sol[i].invoice_status === 'to invoice')) {
          this.sol[i] = this.getName(this.sol[i])
          this.cuentaCorriente.push(this.sol[i])
        }
      }
    },
    getName (item) {
      if (item.name.includes('Cuota de inscripción')) {
        item.name = 'Cuota de inscripción de ' + this.students
        item.price_unit = this.totals.x_enrollment_fee
      } else if (item.name.includes('Cuota de Marzo')) {
        item.name = 'Cuota de Marzo de ' + this.students
        item.price_unit = this.totals.x_march_fee
      } else if (item.name.includes('Cuota de Abril')) {
        item.name = 'Cuota de Abril de ' + this.students
        item.price_unit = this.totals.x_monthly_fee
      } else if (item.name.includes('Cuota de Mayo')) {
        item.name = 'Cuota de Mayo de ' + this.students
        item.price_unit = this.totals.x_monthly_fee
      } else if (item.name.includes('Cuota de Junio')) {
        item.name = 'Cuota de Junio de ' + this.students
        item.price_unit = this.totals.x_monthly_fee
      } else if (item.name.includes('Cuota de Julio')) {
        item.name = 'Cuota de Julio de ' + this.students
        item.price_unit = this.totals.x_monthly_fee
      } else if (item.name.includes('Cuota de Agosto')) {
        item.name = 'Cuota de Agosto de ' + this.students
        item.price_unit = this.totals.x_monthly_fee
      } else if (item.name.includes('Cuota de Septiembre')) {
        item.name = 'Cuota de Septiembre de ' + this.students
        item.price_unit = this.totals.x_monthly_fee
      } else if (item.name.includes('Cuota de Octubre')) {
        item.name = 'Cuota de Octubre de ' + this.students
        item.price_unit = this.totals.x_monthly_fee
      } else if (item.name.includes('Cuota de Noviembre')) {
        item.name = 'Cuota de Noviembre de ' + this.students
        item.price_unit = this.totals.x_monthly_fee
      } else if (item.name.includes('Cuota de Diciembre')) {
        item.name = 'Cuota de Diciembre de ' + this.students
        item.price_unit = this.totals.x_december_fee
      }
      return item
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
